module.exports = __webpack_public_path__ + "img/person_on.0dca2885.png";